"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.encodeToBroadcast = exports.encodeToSign = exports.buildTransactionPayload = void 0;
var algo_msgpack_with_bigint_1 = require("algo-msgpack-with-bigint");
var algosdk_1 = require("algosdk");
var tokens_1 = require("./tokens");
var api_1 = require("./api");
var buildTransactionPayload = function (account, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var amount, recipient, mode, memo, assetId, subAccountId, subAccount, note, params, algoTxn, targetAssetId, sorted;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                amount = transaction.amount, recipient = transaction.recipient, mode = transaction.mode, memo = transaction.memo, assetId = transaction.assetId, subAccountId = transaction.subAccountId;
                subAccount = subAccountId
                    ? account.subAccounts &&
                        account.subAccounts.find(function (t) { return t.id === subAccountId; })
                    : null;
                note = memo ? new TextEncoder().encode(memo) : undefined;
                return [4 /*yield*/, (0, api_1.getTransactionParams)()];
            case 1:
                params = _a.sent();
                if (subAccount || (assetId && mode === "optIn")) {
                    targetAssetId = subAccount && subAccount.type === "TokenAccount"
                        ? (0, tokens_1.extractTokenId)(subAccount.token.id)
                        : assetId
                            ? (0, tokens_1.extractTokenId)(assetId)
                            : "";
                    if (!targetAssetId) {
                        throw new Error("Token Asset Id not found");
                    }
                    algoTxn = (0, algosdk_1.makeAssetTransferTxnWithSuggestedParams)(account.freshAddress, recipient, undefined, undefined, amount.toNumber(), note, Number(targetAssetId), params, undefined);
                }
                else {
                    algoTxn = (0, algosdk_1.makePaymentTxnWithSuggestedParams)(account.freshAddress, recipient, amount.toNumber(), undefined, note, params);
                }
                // Bit of safety: set tx validity to the next 1000 blocks
                algoTxn.firstRound = params.lastRound;
                algoTxn.lastRound = params.lastRound + 1000;
                sorted = Object.fromEntries(Object.entries(algoTxn.get_obj_for_encoding()).sort());
                return [2 /*return*/, sorted];
        }
    });
}); };
exports.buildTransactionPayload = buildTransactionPayload;
var encodeToSign = function (payload) {
    var msgPackEncoded = (0, algo_msgpack_with_bigint_1.encode)(payload);
    return Buffer.from(msgPackEncoded).toString("hex");
};
exports.encodeToSign = encodeToSign;
var encodeToBroadcast = function (payload, signature) {
    var signedPayload = {
        sig: signature,
        txn: payload
    };
    var msgPackEncoded = (0, algo_msgpack_with_bigint_1.encode)(signedPayload);
    return Buffer.from(msgPackEncoded);
};
exports.encodeToBroadcast = encodeToBroadcast;
//# sourceMappingURL=buildTransaction.js.map